import { Component, Input } from '@angular/core';
import { MatRipple } from '@angular/material/core';
import { SvcBtnIconBaseComponent } from '../svc-btn-icon-base.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[svc-outlined-btn-icon]',
  templateUrl: './svc-outlined-btn-icon.component.html',
  styleUrls: ['./svc-outlined-btn-icon.component.scss'],
  hostDirectives: [{ directive: MatRipple, inputs: ['matRippleDisabled:disabled'] }],
  host: {
    '[class.svc-outlined-btn-icon]': `true`,
    '[class.svc-outlined-btn-icon-danger]': `color === 'danger'`,
    '[class.svc-outlined-btn-icon-text]': `color === 'text'`,
    '[class.svc-outlined-btn-icon-primary]': `color === 'primary'`,
    '[class.svc-outlined-btn-icon-on-primary]': `color === 'on-primary'`,
    '[class.svc-outlined-btn-icon-border]': `hasBorder`,
    '[class.svc-outlined-btn-icon-disabled]': `disabled`,
  },
})
export class SvcOutlinedBtnIconComponent extends SvcBtnIconBaseComponent {
  @Input() hasBorder = true;
}
